import { createSlice } from "@reduxjs/toolkit";


const formChangesSlice = createSlice({
  name: "formChanges",
  initialState: {
    formData: [],
    resetControlsVersion: 0,
    removeExcelFilesVersion: 0,
  },
  reducers: {
    storeInitialData(state, action) {
      state.formData = [...action.payload];
    },
    updateFormData(state, action) {
      const { type, value } = action.payload;
      let data = state.formData.find(s => s.type === type);
      const index = state.formData.findIndex(s => s.type === type);
      if (data) {
        data = {
          ...data,
          keyValue: value,
          ...(data?.prevValue !== value && {
            isDataChanged: true,
          }),
          ...(data?.prevValue === value && {
            isDataChanged: false,
          }),
        }
        state.formData[index] = data;
      }
    },
    resetFormData(state) {
      state.formData = [];
    },
    requestResetControls(state) {
      state.resetControlsVersion += 1;
    },
    requestRemoveExcelFiles(state) {
      state.removeExcelFilesVersion += 1;
    }
  }
})

export const { storeInitialData, updateFormData, resetFormData, requestResetControls, requestRemoveExcelFiles } = formChangesSlice.actions;
export default formChangesSlice.reducer;
